//v 1.2.0

window.addEventListener("DOMContentLoaded", () => {
  var body = document.body;
  // Create the modal overlay div
  var modalOverlay = document.createElement("div");
  modalOverlay.id = "modalOverlay";
  body.appendChild(modalOverlay);

  // Create the modal content div
  var modalContent = document.createElement("div");
  modalContent.id = "modalContent";
  modalOverlay.appendChild(modalContent);

  // Create the close icon element
  var closeIcon = document.createElement("div");
  closeIcon.id = "closeIcon";
  closeIcon.innerHTML = "&times;";
  modalContent.appendChild(closeIcon);

  closeIcon.addEventListener("click", function () {
    modalOverlay.style.display = "none";
    body.style.overflow = "auto";
  });

  // Create the iframe element
  var modalIframe = document.createElement("iframe");
  modalIframe.id = "modalIframe";
  modalIframe.setAttribute("allowfullscreen", "");
  modalContent.appendChild(modalIframe);

  modalOverlay.addEventListener("click", function (event) {
    if (event.target === modalOverlay) {
      modalOverlay.style.display = "none";
      body.style.overflow = "auto"; // Restore scrolling when modal is closed
    }
  });

  const getButtonElement =
    document.getElementsByClassName("floori_button")[0].children[0];
  var radioLabels = document.querySelectorAll("input[type=radio] + label");
  var labelValues = [];
  for (var i = 0; i < radioLabels.length; i++) {
    // Access each radio label
    var radioLabel = radioLabels[i];
    var labelValue = radioLabel.textContent || radioLabel.innerText;

    //remove whitespace for reverse
    labelValue = labelValue.replace(/ /g, "");
    if (labelValue.includes("cm") || labelValue.includes("cms")) {
      const splitcm = labelValue.includes("cm")
        ? labelValue.split("cm")[0]
        : labelValue.split("cms")[0];
      labelValue = splitcm.split("x").reverse().join("x").trim();
    }

    // Add the label value to the array
    labelValues.push(labelValue);
  }
  // Join the label values with "|"
  var joinedValues = labelValues.join("|");
  getButtonElement.addEventListener("click", (e) => {
    e.preventDefault();
    modalOverlay.style.display = "block";
    body.style.overflow = "hidden"; // Prevent scrolling when modal is open
    var getSizeVal = document.querySelector('input[name="Size"]:checked').value;
    var getSize = getSizeVal.includes("cm")
      ? getSizeVal.split("cm")[0]
      : getSizeVal.split("cms")[0];
    var width = getSize.split("x")[1];
    var height = getSize.split("x")[0];

    var currentURL = window.location.href;

    var newURL = "";
    const lastChar = currentURL.slice(-1);
    if (lastChar === "/") {
      //checking this if in case of trailing slash at the end, this may cause https://cyrusrugs.com.au/products/tokyo-traditional-rug-3303a-d-grey-l-grey/.js which is incorrect url
      currentURL = currentURL.slice(0, -1);
    } else {
      // Add ".js" to the end
      if (currentURL.includes("?")) {
        const parts = currentURL.split("?"); //checking this in case of query (`?`) exists
        // Add ".js" before the query parameter
        newURL = parts[0] + ".js";
      } else {
        newURL = currentURL + ".js";
      }
    }
    // Fetch the new URL
    fetch(newURL)
      .then((data) => {
        // Handle the response data here
        data.json().then((res) => {
          modalIframe.src = `https://cyrusrugs.explorug.com?customdesignurl=https:${res.featured_image}&initview=Bedroom%201&width=${width}&height=${height}&unit=cm&sizeopt=${joinedValues}`;
          modalIframe.style.display = "block"; // Show the iframe
        });
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
      });
  });
});
